import { Slider } from '@mantine/core';

const LabeledSlider = ({ min, max, value, mb = 'xl', ...otherProps }) => {
  // Generate marks with min, current value, and max — skip current value if it duplicates min or max
  const sliderMarks = [
    { value: min, label: `${min}` },
    ...(value != null && value !== min && value !== max ? [{ value: value, label: `${value}` }] : []),
    { value: max, label: `${max}` },
  ];

  return (
    <Slider
      min={min}
      max={max}
      value={value}
      marks={sliderMarks}
      mb={mb}
      {...otherProps}
    />
  );
};

export default LabeledSlider;
